import { useState, useEffect } from "react";
import { GetImage } from "./GetImage";
import "./styles/Images.css";
import { useNavigate, useLocation } from "react-router";
import { useAuth } from "../hooks/Auth";
import CreatePost from "../components/CreatePost";

const GalleryPage = () => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();

  const author = state?.creator;
  const gallery = state?.gallery;

  const imageCount = 8;
  const [imageIndex, setImageIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [showCreatePost, setShowCreatePost] = useState(false);

  useEffect(() => {
    async function loadImages() {
      const data = await GetImage(imageIndex, imageCount, author, gallery);
      setImages(data);
    }

    loadImages();
  }, [imageIndex, author, gallery]);

  const paddedImages = [
    ...images,
    ...Array(Math.max(imageCount - images.length, 0)).fill(null),
  ];
  const isLastPage = images.length < imageCount;
  const isFirstPage = imageIndex === 0;

  const handlePostCreated = () => {
    setImageIndex(0);
  };
  const handleDelete = async (postId) => {
    const response = await fetch(`/api/gallery/posts?id=${postId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token?.access_token}`,
      },
    });

   if (response.ok) {
      setImages((prev) => prev.filter((img) => img.id !== postId));
    }
  };
  return (
    <div className="container">
      {showCreatePost && (
        <CreatePost
          onClose={() => setShowCreatePost(false)}
          defaultGallery={gallery}
          token={token}
          onPostCreated={handlePostCreated}
        />
      )}

      <div className="gallery-header">
          <h1 className="gallery-title">
          {gallery ? gallery : "Image Gallery"}
          </h1>
      </div>

      <div className="controls-bar">
        <button 
            className="file-button" 
            onClick={() => navigate("/login")}
          >
            Logout
          </button>
          <button
            className="file-button"
            onClick={() => navigate("/editor")}
          >
            Canvas
          </button>
          <button
            className="file-button"
            onClick={() => navigate(`/gallery`)}
          >
            Gallery
          </button>
          <button
            className="file-button"
            onClick={() =>
              navigate(`/profile`, {
                state: { user: user?.id },
              })
            }
          >
            Profile
          </button>
          <div style={{ flex: 1 }} />
          <button
              className="file-button"
              onClick={() => {
                if (token) setShowCreatePost(true);
              }}
            >
              Add Post
            </button>
        </div>

      <div className="gallery-display">
        {paddedImages.map((image, index) =>
          image ? (
            <div key={index} className="gallery-item">
              <img
                src={image.thumbnail}
                alt={image.image_name}
                className="gallery-image"
                onClick={() =>
                  navigate("/post", { state: { post: image } })
                }
              />
              <div className="image-overlay">
                <p className="image-name">{image.image_name}</p>
                <p className="image-author">{image.profiles.username}</p>
                {image.creator === user?.id && (
                  <button onClick={(e) => { e.stopPropagation(); handleDelete(image.id); }}>
                    Delete
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div key={index} className="gallery-placeholder"></div>
          )
        )}
      </div>

      <div className="gallery-buttons">
        <button
          className="previous-button"
          disabled={isFirstPage}
          onClick={() =>
            setImageIndex((prev) => Math.max(prev - imageCount, 0))
          }
        >
          Previous
        </button>

        <button
          className="next-button"
          disabled={isLastPage}
          onClick={() => {
            if (!isLastPage) {
              setImageIndex((prev) => prev + imageCount);
            }
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default GalleryPage;